import axios from '../../../axiosClient.js';

export async function fetchProductsOnBackOrder({ search } = {}) {
  const { data } = await axios.get('/api/products-on-back-order', {
    params: {
      search: String(search ?? '').trim(),
    },
  });

  return {
    backOrders: Array.isArray(data?.backOrders) ? data.backOrders : [],
    discontinued: Array.isArray(data?.discontinued) ? data.discontinued : [],
    counts: data?.counts || { backOrders: 0, discontinued: 0, total: 0 },
  };
}
